// register vue composition api globally
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import Home from '@/components/Home.vue';

import './styles/main.scss';
import './styles/tailwind.css';

import { TRouteName } from './types/routing';

// Create app
const app = createApp(App);

// Set up router
const routes = [{ path: '/', name: TRouteName.Home, component: Home }];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const pinia = createPinia();

// Use all required modules
app.use(router);
app.use(pinia);

// Mount app
app.mount('#taylors-home');
